import { connect } from "react-redux";

import { changeSelectedError } from "../model/Fehlerspeicher";

import Stoerspeicher from "./Stoerspeicher";

export default connect(state => ({
	compressors: state.ablauf.compressors,
	units: state.units,
	error_log: state.error_log.log,
	fehlertexte: state.fehlertexte,
	locale: state.current_locale_i18n_key,
	selected: state.error_log.selected
}), dispatch => ({
	changeSelected: item => dispatch(changeSelectedError(item))
}))(Stoerspeicher);